module.exports = __webpack_public_path__ + "img/ManualMode.f3b63a4d.svg";